/*================================

	將所有使用者頭像相關的載入邏輯寫在一起

	若是沒有大圖的話或是無法順利載入頭像的話，則顯示使用者的名稱第一個字跟底色當作封面圖

	其他邏輯參照 cupoy_image.js

	Author : Alan
	最後更新時間 : 2016 / 04 / 01

================================*/


window.InifECApp.directive('cupoyAvatarImage', ['$timeout', 'cupoyImageURLCache',
	function($timeout, cupoyImageURLCache) {
		return {
			restrict: "AE",
			link: function(scope, element, attrs) {

				var colors = [
						"#FF5722",
						"#FF9800",
						"#FFC107",
						"#DAC827",
						"#CDDC39",
						"#03A9F4",
						"#00BCD4",
						"#009688",
						"#259B24",
						"#8BC34A",
						"#5677FC",
						"#3F51B5",
						"#673AB7",
						"#9C27B0",
						"#E91E63"
					];

				scope.$watchGroup([attrs.cupoyAvatarImage, attrs.fallbackText], function(newValues, oldValues) {
					onImageSrcChange();
				});

				var isPreloading = false;
				var isShowText = true;
				var preloadingURL;
				var preloadingImage;

				var colorSize = colors.length;

				var cache = cupoyImageURLCache;
				var debugcache = {};
				var isBGImage = element[0].tagName !== 'IMG';

				if (isBGImage) {
					element.css('will-change', 'transform');
				}

				var onImageSrcChange = function() {
					if(scope.isDummy){
						return;
					}
					// console.log("fallbackText = " + attrs.fallbackText);
					isShowText = attrs.isShowText == 'false' ? false : true;

					// 清掉原本的圖
					loadImage('about:blank');
					element.removeClass('show');

					var imagesrc = scope.$eval(attrs.cupoyAvatarImage); // 第一次載入的圖片
					var fallbackImageUrl = scope.$eval(attrs.fallbackImageUrl); // 失敗後第二次載入的圖片

					if (isPreloading) {
						// console.log("cupoy image src changed during preloading");
						// check if imagesrc were the same
						if (preloadingURL !== imagesrc) {
							// abort preloading/loading
							preloadingImage.onload = undefined;
							preloadingImage.onerror = undefined;
							preloadingImage = undefined;
							isPreloading = false;
							preloadingURL = undefined;
							// console.log('abort preloading');
						}
					}

					// 沒有給source url就什麼也不做
					if (!imagesrc || imagesrc === 'about:blank') {
						useTextAndBackgroundToReplaceThumburl();
						return;
					}
					// console.log('imagesrc changed to ' + imagesrc);

					// reset
					element.html("");
					requestAnimationFrame(function() {
						element.css({
							'background-color': "#E2DFDE"
						});
					});

					var cachekey = imagesrc;
					// check if we have cached url 
					if (cache.get(cachekey)) {
						// console.log('image url has been loaded key = ' + cachekey + ', value = ' + cache.get(cachekey));
						imagesrc = cache.get(cachekey);
						loadImage(imagesrc);
						return;
					}

					requestAnimationFrame(function() {
						preloadImage(imagesrc, fallbackImageUrl);
					});
				}

				var loadImage = function(imagesrc) {

					if (isBGImage) {
						// 啟動fade in css
						element.css('background-image', 'url(' + imagesrc + ')');
						// element.css('image-rendering', 'pixelated'); // 用css讓圖變清晰
						element.addClass('show');
					} else {
						// 啟動fade in css
						element.attr('src', imagesrc);
						// element.css('image-rendering', 'pixelated'); // 用css讓圖變清晰
						element.addClass('show');
					}
				};

				var preloadImage = function(imagesrc, fallbackImageUrl) {
					isPreloading = true;
					preloadingURL = imagesrc;

					var image = new Image();
					preloadingImage = image;
					image.src = imagesrc;

					var srcfinalized = false;
					var cachekey = imagesrc;
					// element.css('will-change', 'opacity');
					var imageonload = function(event) {
						cache.put(cachekey, imagesrc);
						isPreloading = false;
						preloadingURL = undefined;
						preloadingImage = undefined;
						loadImage(imagesrc);
						image.onload = undefined;
						image.onerror = undefined;
						image = undefined;
						srcfinalized = true;
					}

					if (!image.complete) {
						image.onload = imageonload;

					} else {
						imageonload();
						return;
					}

					image.onerror = function(event) {

						if (srcfinalized) { // 第二次錯誤, 連fallback都載入失敗，就改顯示文字
							image.onload = undefined;
							image.onerror = undefined;
							image = undefined;
							if (!cache.get(cachekey)) {
								cache.put(cachekey, 'about:blank');
							}
							isPreloading = false;
							preloadingURL = undefined;
							preloadingImage = undefined;
							// console.log('imagesrc fallback failed ');
							useTextAndBackgroundToReplaceThumburl();
							return;
						}

						imagesrc = 'about:blank';

						if (fallbackImageUrl) {
							imagesrc = fallbackImageUrl;
							// console.log('imagesrc fallback to ' + fallbackImageUrl);
							// cache.put(cachekey, imagesrc);
						}
						
						srcfinalized = true;
						image.src = imagesrc;
					};
				};

				var useTextAndBackgroundToReplaceThumburl = function() {
					var text = scope.$eval(attrs.fallbackText);
					// var text = attrs.fallbackText;
					if(!text || !isBGImage) {
						return;
					}

					var hash = Math.abs(hashCode(text) % colorSize);
					text = text.substring(0,1);
					element.css({
						'background-color': colors[hash]
					});

					if(isShowText) {
						element.html(text.substring(0,1));
					}
				}

				var hashCode = function(text) {
				    var hash = 0,
				        i, chr, len;
				    if (text.length == 0) return hash;
				    for (i = 0, len = text.length; i < len; i++) {
				          chr = text.charCodeAt(i);
				          hash = ((hash << 5) - hash) + chr;
				          hash |= 0; // Convert to 32bit integer
				    }

				    return hash;
				};
			}
		};
	}
]);